import type { DecisionFilter } from './endpoints';

/** Single source of truth for react-query cache keys. */
export const queryKeys = {
  session: ['session'] as const,
  dashboard: ['dashboard'] as const,
  health: ['health'] as const,
  strategyConfig: ['strategy', 'config'] as const,
  position: ['position'] as const,
  orders: ['orders'] as const,
  trades: ['trades'] as const,
  decisions: (filter: DecisionFilter) => ['decisions', filter] as const,
  audit: (filter: { from?: string; to?: string }) => ['audit', filter] as const,
  connections: ['connections'] as const,
  backtests: ['backtests'] as const,
  backtest: (id: string) => ['backtests', id] as const,
} as const;

/** Root key prefixes an SSE frame can invalidate. */
export const invalidationGroups = {
  dashboard: [queryKeys.dashboard, queryKeys.health],
  decision: [queryKeys.dashboard, ['decisions']],
  position: [queryKeys.dashboard, queryKeys.position, queryKeys.orders, queryKeys.trades],
  order: [queryKeys.orders, queryKeys.position, queryKeys.dashboard],
  incident: [queryKeys.dashboard, queryKeys.health],
  connection: [queryKeys.connections, queryKeys.dashboard, queryKeys.health],
} as const satisfies Record<string, readonly (readonly unknown[])[]>;
